export const UNIFIED_TV_COMMANDS = [
  { command: 'power', label: 'Power', icon: '⏻ Power' },
  { command: 'input', label: 'Input', icon: '⏏︎ Input' },
  { command: 'wake', label: 'Wake', icon: '☀ Wake' },
  { command: 'sleep', label: 'Sleep', icon: '☾ Sleep' },
  { command: 'settings', label: 'Settings', icon: '⚙︎ Settings' },
  { command: 'vol_up', label: 'Volume Up', icon: '＋' },
  { command: 'vol_down', label: 'Volume Down', icon: '－' },
  { command: 'mute', label: 'Mute', icon: '🔇 Mute' },
  { command: 'nav_up', label: 'Up', icon: '▲' },
  { command: 'nav_down', label: 'Down', icon: '▼' },
  { command: 'nav_left', label: 'Left', icon: '◀' },
  { command: 'nav_right', label: 'Right', icon: '▶' },
  { command: 'ok', label: 'OK', icon: 'OK' },
  { command: 'chan_up', label: 'Channel Up', icon: 'CH ▲' },
  { command: 'chan_down', label: 'Channel Down', icon: 'CH ▼' },
  { command: 'last', label: 'Last Channel', icon: '⟲ Last' },
  { command: 'back', label: 'Back', icon: '↶ Back' },
  { command: 'home', label: 'Home', icon: '⌂ Home' },
  { command: 'tv_home', label: 'TV Home', icon: '⌂ TV' },
  { command: 'hdmi_1', label: 'HDMI 1', icon: 'HDMI 1' },
  { command: 'hdmi_2', label: 'HDMI 2', icon: 'HDMI 2' },
  { command: 'hdmi_3', label: 'HDMI 3', icon: 'HDMI 3' },
  { command: 'hdmi_4', label: 'HDMI 4', icon: 'HDMI 4' },
  { command: 'rew', label: 'Rewind', icon: '⏮' },
  { command: 'play_pause', label: 'Play/Pause', icon: '⏯' },
  { command: 'ff', label: 'Fast Forward', icon: '⏭' },
  { command: 'stop', label: 'Stop', icon: '⏹' },
  { command: 'num_1', label: '1', icon: '1' },
  { command: 'num_2', label: '2', icon: '2' },
  { command: 'num_3', label: '3', icon: '3' },
  { command: 'num_4', label: '4', icon: '4' },
  { command: 'num_5', label: '5', icon: '5' },
  { command: 'num_6', label: '6', icon: '6' },
  { command: 'num_7', label: '7', icon: '7' },
  { command: 'num_8', label: '8', icon: '8' },
  { command: 'num_9', label: '9', icon: '9' },
  { command: 'dash', label: 'Dash', icon: '−' },
  { command: 'num_0', label: '0', icon: '0' },
  { command: 'enter', label: 'Enter', icon: '⏎' },
  { command: 'color_red', label: 'Red', icon: '' },
  { command: 'color_green', label: 'Green', icon: '' },
  { command: 'color_yellow', label: 'Yellow', icon: '' },
  { command: 'color_blue', label: 'Blue', icon: '' },
];

export const LG_TV_COMMANDS = UNIFIED_TV_COMMANDS.filter(({ command }) =>
  !['input', 'settings'].includes(command));
